// Sample data for event list
const sampleEvents = [
  {
    Reference: "EVT-001",
    Label: "dummy",
    Description: "just a test",
    Ticket: "TICKET-123",
    Severity: "high",
    Status: "active",
  },
  {
    Reference: "EVT-002",
    Label: "network outage",
    Description: "Network connectivity lost in sector 7",
    Ticket: "TICKET-456",
    Severity: "medium",
    Status: "active",
  },
  {
    Reference: "EVT-003",
    Label: "power failure",
    Description: "Unexpected power shutdown in building A",
    Ticket: "TICKET-789",
    Severity: "high",
    Status: "active",
  },
  {
    Reference: "EVT-004",
    Label: "maintenance",
    Description: "Scheduled maintenance for HVAC system",
    Ticket: "TICKET-321",
    Severity: "low",
    Status: "active",
  },
  {
    Reference: "EVT-005",
    Label: "security alert",
    Description: "Unauthorized access detected",
    Ticket: "TICKET-654",
    Severity: "medium",
    Status: "active",
  },
  {
    Reference: "EVT-006",
    Label: "software update",
    Description: "Firmware update required for device X",
    Ticket: "TICKET-987",
    Severity: "medium",
    Status: "active",
  },
];
import React, { useState } from "react";
import { toast } from "react-toastify";
import WeatherIcon from "../../assets/icons/monitoring/monitor_types/mon_weather.svg2";
import LogicIcon from "../../assets/icons/library_logic.svg2";
import EventIcon from "../../assets/icons/Icon_Library/application icons/assets/events.svg2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCircle,
  faEdit,
  faPause,
  faRotateLeft,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import EventsTimeLine from "./EventsTimeLine";
import MyPagination from "../Common/MyPagination";
import EventModal, { EventDetailsTable } from "./EventModal";
import MyModal from "../Common/MyModal";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { mapsAPI } from "../store/slices/mapsSlice";
import {
  useCloseEventMutation,
  useCloseNoSolutionEventMutation,
  useGetEventsQuery,
  useUpdateEventMutation,
  useUpdateEventStatusMutation,
} from "../store/slices/settingsSlice";
import EventsAssetsSlider from "./EventsAssetsSlider";
import EventTicketsSlider from "./EventTicketsSlider";
import MapAssetsSlider from "./MapAssetsSlider";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

function LiveEventList({
  assetUuid,
  activeEventsOnly,
  eventSolution,
  filters,
}) {
  const confirmDialog = useConfirmDialog();
  const [logicConnected, setLogicConnected] = useState();
  const [order, setOrder] = useState();
  const [pagination, setPagination] = useState({
    offset: 0,
    perPage: 12,
  });
  const { data: { events, total } = { events: [], total: 0 }, refetch } =
    useGetEventsQuery({
      ...pagination,
      ...(assetUuid && { assets: [assetUuid] }),
      ...(activeEventsOnly && { status: "active" }),
      ...(eventSolution && { solutionClientUuid: eventSolution.Uuid }),
      ...filters,
    });
  const [addEvents] = useUpdateEventMutation();

  const [setEventStatus] = useUpdateEventStatusMutation();
  const dispatch = useDispatch();
  const closeEvent = async (uuid) => {
    if (
      !(await confirmDialog(
        "Close Event",
        "Are you sure you want to close this event?"
      ))
    ) {
      return;
    }

    await setEventStatus({ uuid, status: "closed" }).then((res) => {
      if ("data" in res) {
        toast.success("Event closed successfully");
        refetch();
      }
    });

    dispatch(mapsAPI.util.invalidateTags(["Locations"]));
  };
  const [closeSolutionEvent] = useCloseEventMutation();
  const [closeNoSolutionEvent] = useCloseNoSolutionEventMutation();

  return (
    <div>
      <div className="p-3 rounded-3 bg-white">
        <table className="table mt-3">
          <thead>
            <tr>
              <th>Reference</th>
              <th>User Reference</th>
              <th>Status</th>
              <th>Severity</th>
              <th>Solution Name</th>
              <th>Assets</th>
              <th>Started At</th>
              <th>
                <div className="d-flex justify-content-between align-items-end">
                  End At{" "}
                  <button onClick={() => refetch()} className="btn btn-sm">
                    <FontAwesomeIcon icon={faRotateLeft} />
                  </button>
                </div>{" "}
              </th>
            </tr>
          </thead>
          <tbody>
            {(events || []).map((item, i) => (
              <tr key={i}>
                <td>
                  <div className="d-flex gap-2">
                    <EventsTimeLine
                      eventUuid={item.Uuid}
                      eventSolution={eventSolution}
                      label={item.Reference}
                    />{" "}
                    <MapAssetsSlider
                      item={item}
                      eventSolution={eventSolution}
                      isEventLocations
                    />
                  </div>
                </td>
                <td>
                  {item.UserReference || (
                    <span className="text-muted fw-lighter">N/A</span>
                  )}
                </td>

                <td>
                  <span
                    className={`badge rounded-pill ${
                      item.Status === "active"
                        ? "bg-danger"
                        : item.Status === "closed"
                        ? "bg-secondary"
                        : item.Status === "resolved"
                        ? "bg-success"
                        : item.Status === "creating"
                        ? "bg-warning"
                        : ""
                    }`}
                  >
                    {item.Status}
                    {item.Status === "creating" ? (
                      <FontAwesomeIcon
                        size="sm"
                        className="ms-2"
                        icon={faSpinner}
                        spin
                      />
                    ) : null}
                  </span>
                </td>
                <td>
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor:
                        item.Severity === "critical"
                          ? "red"
                          : item.Severity === "high"
                          ? "orange"
                          : item.Severity === "medium"
                          ? "gold"
                          : "seagreen",
                    }}
                  >
                    {item.Severity}
                  </span>
                </td>
                <td>
                  {item.SolutionClient?.SolutionName || (
                    <span className="text-muted fw-lighter">N/A</span>
                  )}
                </td>

                <td>{item.AssetsCount || 0}</td>

                <td>{new Date(item.StartAt).toLocaleString()}</td>
                <td>
                  {item.EndAt.Valid ? (
                    new Date(item.EndAt.Time).toLocaleString()
                  ) : eventSolution?.Features?.some(
                      (f) =>
                        f.Feature === "close-event" && f.Status === "enabled"
                    ) ? (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={async () => {
                        if (
                          await confirmDialog(
                            "Close Event",
                            "Are you sure you want to close this event?"
                          )
                        ) {
                          closeSolutionEvent({
                            SolutionClientUuid: eventSolution?.Uuid,
                            ID: item.Uuid,
                            Message: "",
                          }).then((res) => {
                            if ("data" in res) {
                              toast.success("Event closed successfully");
                              refetch();
                            }
                          });
                        }
                      }}
                    >
                      Stop Now
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={async () => {
                        if (
                          await confirmDialog(
                            "Close Event",
                            "Are you sure you want to close this event?"
                          )
                        ) {
                          closeNoSolutionEvent({
                            SolutionClientUuid: eventSolution?.Uuid,
                            ID: item.Uuid,
                            Message: "",
                          }).then((res) => {
                            if ("data" in res) {
                              toast.success("Event closed successfully");
                              refetch();
                            }
                          });
                        }
                      }}
                    >
                      Stop Now
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <MyPagination
          total={total}
          onPaginate={(page, perPage) => {
            setPagination((p) => ({ ...p, page, perPage }));
          }}
        />
      </div>
    </div>
  );
}

export default LiveEventList;
